import { I18n } from '@calendly/i18n'
import PropTypes from 'prop-types'

export const MembershipRoleDescription = ({ membershipRole }) => ({
  user: I18n.t('publisher.organization.membership_role.user_description'),
  admin: I18n.t('publisher.organization.membership_role.admin_description'),
  owner: I18n.t('publisher.organization.membership_role.owner_description')
}[membershipRole])

MembershipRoleDescription.propTypes = {
  membershipRole: PropTypes.oneOf(['user', 'admin', 'owner']).isRequired
}
